var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-jobs loader-container"},[_c('h2',[_vm._v("Jobs")]),_c('div',{staticClass:"actions loader-container"},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.deleteCustomerJobs($event)}}},[_vm._v("Clear Jobs")]),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.getCustomerJobs($event)}}},[_vm._v("Refresh")]),_c('Loader',{attrs:{"loading":_vm.processingAction}})],1),_c('div',{staticClass:"table-wrapper loader-container"},[(_vm.customerJobs)?_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'Customer',
          field: 'customerComponent.customer.customerName'
        },
        {
          label: 'Component',
          field: 'customerComponent.component.componentName'
        },
        {
          label: 'Action',
          field: 'action'
        },
        {
          label: 'Date Created',
          field: 'dateCreated',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Created By',
          field: 'createdBy'
        },
        {
          label: 'Date Run',
          field: 'dateRun',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Run By',
          field: 'runBy'
        },
        {
          label: 'Date Completed',
          field: 'dateCompleted',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Date Failed',
          field: 'dateFailed',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Error',
          field: 'error'
        }
      ],"rows":_vm.customerJobs}}):_vm._e(),_c('Loader',{attrs:{"loading":_vm.loadingJobs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }